module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Text/Text-5e589cf4d08778bf04b6cada1fcbf940.svg";